import Vue from "vue";
import modalDismiss from "./modalDismiss";
import applyRules from "./applyRules";
import btnClipboard from "./btnClipboard";

// Registrar diretivas funcionais no Vue
Vue.directive("modalDismiss", modalDismiss);
// Vue.directive('applyRules', applyRules)
// Vue.directive('btnClipboard', btnClipboard)

export default {
  modalDismiss,
  applyRules,
  btnClipboard,
};
